(ns net.kestec.mhda-pilgrimage.public.landing
  (:require
    ["@mui/material/Grid2" :default Grid]
    ["@mui/material/Typography" :default Typography]
    ["@mui/material/Card" :default Card]
    ["@mui/material/CardContent" :default CardContent]
    [net.kestec.mhda-pilgrimage.route :as route]
    [day8.re-frame.http-fx]
    [net.kestec.mhda-pilgrimage.db :as-alias db]
    [net.kestec.mhda-pilgrimage.public.page-structure :refer [base-page]]
    [net.kestec.mhda-pilgrimage.public.news.widgets.public-news-block :refer [public-news-block]]
    [net.kestec.mhda-pilgrimage.public.application.widgets.welcome-action-block :refer [welcome-action-block]]

    ))


(defn main []
  [base-page
   [:<>
    [:> Grid {:container true :direction "row" :spacing 1}
     [:> Grid {:size {:xs 12 }}
      [:> Grid {:container true :direction "row" :spacing 1}
       [:> Grid {:size {:xs 12 :md 12}}
        [welcome-action-block]
        [public-news-block]


        ]

       ]]

     ]

    [:br]
    [:br]

    ]])


